<template>
  <el-form label-position="top">
    <el-form-item label="坡度批次計算">
      <el-checkbox v-model="form.ai_use_slope_batch">啟用</el-checkbox>
    </el-form-item>
    <el-button
      type="primary"
      :disabled="!stationId"
      @click="saveAiUseSlopeBatch"
    >
      儲存
    </el-button>

    <el-divider></el-divider>

    <el-form-item label="AI 參考儀器">
      <el-select
        v-model="form.ai_ref_instruments"
        multiple
        filterable
        placeholder="選擇參考儀器"
        style="width: 100%;"
      >
        <el-option
          v-for="instrument in instrumentList"
          :key="instrument._id"
          :label="instrument.name"
          :value="instrument._id"
        />
      </el-select>
    </el-form-item>
    <el-button
      type="primary"
      :disabled="!stationId"
      @click="saveAiRefInstruments"
    >
      儲存
    </el-button>
  </el-form>
</template>

<script>
export default {
  props: {
    stationId: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {
      form: {
        ai_use_slope_batch: false,
        ai_ref_instruments: [],
      },
      instrumentList: [],
    };
  },
  computed: {
    selectedStation() {
      return this.$store.getters['data/stationList'].find(s => s._id === this.stationId);
    },
  },
  watch: {
    stationId(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.initForm();
      }
    },
  },
  mounted() {
    this.getInstrumentList();
    this.initForm();
  },
  methods: {
    initForm() {
      const station = this.selectedStation;
      if (station) {
        this.form.ai_use_slope_batch = station.ai_use_slope_batch || false;
        this.form.ai_ref_instruments = station.ai_ref_instruments || [];
      } else {
        this.form.ai_use_slope_batch = false;
        this.form.ai_ref_instruments = [];
      }
    },
    getInstrumentList(isUpdate = false) {
      return this.$store
        .dispatch('data/getInstrumentList', isUpdate)
        .then(res => {
          this.instrumentList = res;
        })
        .catch(this.$notifyError);
    },
    async saveAiUseSlopeBatch() {
      try {
        await this.$axios({
          category: 'admin',
          method: 'put',
          apiName: `station/${this.stationId}/ai-use-slope-batch`,
          data: { ai_use_slope_batch: this.form.ai_use_slope_batch },
        });
        this.$notifySuccess('儲存成功');
        this.$store.dispatch('data/getStationList', true);
      } catch (error) {
        this.$notifyError(error);
      }
    },
    async saveAiRefInstruments() {
      try {
        await this.$axios({
          category: 'admin',
          method: 'put',
          apiName: `station/${this.stationId}/ai-ref-instruments`,
          data: { ai_ref_instruments: this.form.ai_ref_instruments },
        });
        this.$notifySuccess('儲存成功');
        this.$store.dispatch('data/getStationList', true);
      } catch (error) {
        this.$notifyError(error);
      }
    },
  },
};
</script>
